import React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  NavLink,
  Redirect,
  withRouter
} from 'react-router-dom'
import Notifications, {notify} from 'react-notify-toast'
import Auth from './Auth'
import News from './News'
import Setup from './Setup'
import Daily from './Daily'
import Scheduler from './Scheduler'
import Tasks from './Tasks'
import moment from 'moment'

// TODO: give a chance to https://www.npmjs.com/package/react-services

moment.locale('es')
moment.updateLocale('es', {
  months : [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
      "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ],
  monthsShort : [
      "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul",
      "Ago", "Sep", "Oct", "Nov", "Dic"
  ],
  weekdays : ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado" ],
  weekdaysMin : ["D", "L", "M", "X", "J", "V", "S" ],
  weekdaysShort : ["D", "L", "M", "X", "J", "V", "S" ],
  week : {
    dow : 1
  }
})

const App = () => (
      <Router>
      <div className="App noselect">
        <header className="App-header">
          <div className="titleDiv">
            <img alt="David Garrido App" src="sello.png" border="0" className="logoImg" />
          </div>
          <div className="menuDiv">

              <ul className="menu">
                <li>
                  <NavLink to="/news" title="Noticias" activeClassName="activeLink">
                    <i className="material-icons">new_releases</i>
                    <br/>
                    <span className="menuTitle">Noticias</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/scheduler" title="Citas" activeClassName="activeLink">
                    <i className="material-icons">calendar_today</i>
                    <br/>
                    <span className="menuTitle">Citas</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/tasks" title="Tareas" activeClassName="activeLink">
                    <i className="material-icons">list_alt</i>
                    <br/>
                    <span className="menuTitle">Tareas</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/daily" title="Diario" activeClassName="activeLink">
                    <i className="material-icons">book</i>
                    <br/>
                    <span className="menuTitle">Diario</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/setup" title="Configuración" activeClassName="activeLink">
                    <i className="material-icons">settings</i>
                    <br/>
                    <span className="menuTitle">Configuración</span>
                  </NavLink>
                </li>
                <li><AuthButton/></li>
              </ul>

          </div>
        </header>

        <main>
          <div className="row rowDiv contentDiv">
            <Switch>
              <Route exact path="/" component={Login}/>
              <Route exact path="/public" component={Login}/>
              <Route exact path="/login" component={Login}/>
            </Switch>
              <PrivateRoute exact path="/news" component={News}/>
              <PrivateRoute exact path="/scheduler" component={Scheduler}/>
              <PrivateRoute exact path="/daily" component={Daily}/>
              <PrivateRoute exact path="/setup" component={Setup}/>
              <PrivateRoute exact path="/tasks" component={Tasks}/>
          </div>
        </main>
        
        <Notifications />
      </div>
      
      </Router>
)


const AuthButton = withRouter(({ history }) => (
  Auth.isAuthenticated ? (
    <div className="logoutSpan">
      <span  onClick={() => {
        Auth.signout(() => history.push('/'))
      }}><i className="material-icons" title="Logout">exit_to_app</i></span>
      <br/>
      { 
      /*
      <small className="userName">
        {firebase.auth().currentUser.email}
      </small>
      */ 
      }
    </div>
  ) : 
  <div className="logoutSpan">
    <span  onClick={() => {
      Auth.signout(() => history.push('/'))
    }}><i className="material-icons" title="Logout">exit_to_app</i></span>
    
  </div>
))

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    Auth.isAuthenticated ? (
      <Component {...props}/>
    ) : (
      <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }}/>
    )
  )}/>
)


class Login extends React.Component {
  state = {
    redirectToReferrer: false,
    wellcome: false
  }

  login = () => {
    Auth.authenticate(() => {
      const user = firebase.auth().currentUser.email
      if(!this.state.wellcome){
        notify.show ('Bienvenid@ '+user+'!', 'warning', 1250);
      }
      this.setState({ redirectToReferrer: true, wellcome: true })
    })
  }

  render() {
    const { redirectToReferrer } = this.state
    
    if (redirectToReferrer) {
      return (
        <Redirect to={{
        pathname: '/news',
        state: { from: this.props.location, user: this.state.user }
      }}/>
      )
    }
    
    return (
      <div className="loginDiv">
        <div className="container waitDiv">
          <div ref="waitAnimDiv" className="waitAnim"> </div>
        </div>
          <div ref="loginFormDiv" className="loginCenterDiv">
            <div>  
                <label>Usuario</label>
                <input className="form-control" ref="email" type="text" placeholder="usuario" /> 
            </div>
            <br/>
            <div> 
              <label>Contraseña</label>
              <input className="form-control" ref="pass" type="password" placeholder="contraseña" /> 
            </div>   
            <br/>    
            <button className='btn btn-light btn-sm' 
                    onClick={() => this.handleEmailAuth()} 
                    title="Login">
                    Identifícate
            </button>
            &nbsp;&nbsp;
            <button className='btn btn-light btn-sm' 
                    onClick={() => this.registerUser()} 
                    title="Login" >
                    Regístrate
            </button>

            <br/>
            <br/>

            <button className='btn btn-light btn-sm' 
                    onClick={() => this.handleGoogleAuth()} 
                    title="Google Login" >
                Identifícate con tu cuenta de Google
            </button>            

            <br/>
            <br/>
          </div>
      </div>
    )
  }
  
  registerUser(){
      const auth = firebase.auth()
      auth.createUserWithEmailAndPassword(this.refs.email.value, this.refs.pass.value)
      .then( result => {
        // registration ok, store user in firebase
        const ref = firebase.database().ref()
        ref.child("users").push({
          email: result.user.email,
          role: 'user',
          state: true,
          stars: 0
        }).then( snap => {
          // store role
          // ref.child("roles").child(snap.key).set('user')
        })
      })
      .catch( error => {
        console.log('registerUser > error detected: ') 

        if ( error.code === 'auth/email-already-in-use' ) {
          notify.show ('Ya existe usuario con email ' + this.refs.email.value, 'error', 1250);
        } else if ( error.code === 'auth/invalid-email' ) {
          notify.show ('Formato de email no válido: ' + this.refs.email.value, 'error', 1250);
        } else if ( error.code === 'auth/weak-password' ) {
          notify.show ('Contraseña demasiado débil. Introduce una contraseña más compleja combinando letras/números, mayúsculas/minúsculas, ... ', 'error', 1250);
        } 
        
      });
      this.checkUserLogin()
  }

  handleGoogleAuth(){

      const ref = firebase.database().ref()
      const auth = firebase.auth()
      const provider = new firebase.auth.GoogleAuthProvider();
      auth.signInWithPopup(provider)
      .then( result => {

        console.log('user email: ' + result.user.email)

        ref.child("users").orderByChild("email").equalTo(result.user.email).on ( 'value', snap => {
          console.log('registerUserGmail check user: ')
          if (snap.numChildren()===0){
            ref.child("users").push({
              email: result.user.email,
              role: 'user',
              state: true
            }).then( snap => {
              // store role
              // ref.child("roles").child(snap.key).set('user')
            })
            console.log('user added')
          }
        })

      })
      .catch( error => {
        console.log('registerUserGmail > error detected: ') 
        console.log(error) 

        if ( error.code === 'auth/email-already-in-use' ) {
          notify.show ('Ya existe usuario con email ' + this.refs.email.value, 'error', 1250);
        } else if ( error.code === 'auth/invalid-email' ) {
          notify.show ('Formato de email no válido: ' + this.refs.email.value, 'error', 1250);
          alert( )
        } else if ( error.code === 'auth/weak-password' ) {
          notify.show ('Contraseña demasiado débil. Introduce una contraseña más compleja combinando letras/números, mayúsculas/minúsculas, ... ', 'error', 1250);
        } 
        
      });
      this.checkUserLogin()
  }

  handleEmailAuth(){
      const auth = firebase.auth()
      auth.signInWithEmailAndPassword(this.refs.email.value, this.refs.pass.value)
      .then( result => {
        this.userAuthOk(result)
      })
      .catch( error => {
        console.log('handleEmailAuth > error detected: ') 

        console.log('Error code: ' + error.code) 
        console.log('Error msg: ' + error.message) 

        if ( error.code === 'auth/wrong-password' ) {
          notify.show ('Contraseña incorrecta', 'error', 1250)
        } else if ( error.code === 'auth/invalid-email' ) {
          notify.show ('Formato de email no válido: ' + this.refs.email.value, 'error', 1250)
        } 

      });
      this.checkUserLogin()
  }

  userAuthOk(user) {

      let ref = firebase.database().ref()
      let usersRef = ref.child("users")

      // search user by email
      const usersSearchRef = usersRef.orderByChild("email").equalTo(user)
      usersSearchRef.once('value', snaps => {
        let ok=false
        snaps.forEach ( user => {
          if ( user.val().state!==false && user.val().email === firebase.auth().currentUser.email ){
            this.login()
            ok=true
          }
        })
        if(!ok){
          notify.show ('Usuario desactivado', 'error', 1250)
        }
      })
  }

  componentDidMount(){
      if(!Auth.isAuthenticated){
          this.checkUserLogin()
      }      
  }

  checkUserLogin(){

      firebase.auth().onAuthStateChanged( user => {
         if(user){
             this.userAuthOk(user.email)
         } else{
            if (this.refs.loginFormDiv!==undefined){
              this.refs.loginFormDiv.style.visibility = "visible"
            }
         }
         if (this.refs.loginFormDiv!==undefined){
          this.refs.waitAnimDiv.style.visibility = "hidden"
         }
      });
  }

}

export default App;
